import React from "react";
import FormatDateTime from "../../../utils/formatDateTime";
import {Switch} from "../../../components/ui/switch"; 
import apiClient from "../../../utils/apiClient";

const OptimusToggleTable = ({ toggleData, handleToggleUpdate }) => {
  // Safety check - ensure toggleData is an array
  if (!Array.isArray(toggleData)) {
    return (
      <div className="text-white p-4">
        <p>No toggle data available or data is not in the correct format.</p>
      </div>
    );
  }

  // Group data by category
  const groupedData = toggleData.reduce((acc, item) => {
    const category = item.category || "uncategorized";
    if (!acc[category]) acc[category] = [];
    acc[category].push(item);
    return acc;
  }, {});

  // Generate table rows
  const generateRows = (dataArray) =>
    dataArray.map((item, index) => (
      <tr
        key={index}
        className="bg-black z-0 border-b last-of-type:border-b-0 border-gray-900 font-medium text-white hover:bg-black/90"
      >
        {Object.keys(item).map((key, idx) => (
          <td
            key={idx}
            className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 ${
              key === "category" 
                ? item.category === "sell" 
                  ? "bg-rose-600" 
                  : item.category === "buy" 
                  ? "bg-emerald-600" 
                  : item.category === "bot"
                  ? "bg-blue-600"
                  : "bg-zinc-700"
                : ""
            }`}
              
          >
            {key === "enabled" ? (
              <Switch
                checked={item.enabled}
                onCheckedChange={() => handleToggleUpdate(item.toggle_name, item.enabled)}
              />
            ) : key === "updated_at" ? (
              FormatDateTime(item[key])
            ) : (
              item[key]
            )}
          </td>
        ))}
      </tr>
    ));

  // Generate tables by category
  const generateTables = () =>
    Object.entries(groupedData).map(([category, data], index) => (
      <div
        key={index}
        className={`z-0 w-full h-full animate-reveal transition-all duration-500 ease-in row-span-2`}
      >
        <h2 className="text-white text-lg font-semibold uppercase mb-3">
          {category}
        </h2>
        {data.length > 0 ? (
          <table className="bg-black border border-gray-700 text-sm w-full relative z-0">
            <thead className="bg-[#0F0F0F] text-sm text-left">
              <tr className="text-white border-b border-gray-800">
                {Object.keys(data[0]).map((header, idx) => (
                  <th
                    key={idx}
                    className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold"
                  >
                    {header.replace(/_/g, ' ').toUpperCase()}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>{generateRows(data)}</tbody>
          </table>
        ) : (
          <h3 className="text-gray-300 text-md font-medium uppercase">
            No data in {category}
          </h3>
        )}
      </div>
    ));

  return (
    <div className="grid grid-cols-2 gap-x-6 overflow-y-auto w-full px-6">
      {generateTables()}
    </div>
  );
};

export default OptimusToggleTable;